import { FC, useEffect, useState } from "react";
import "../create.css";
import { useNavigate, useParams } from "react-router-dom";
import { useConfig } from "../../Auth/Auth";
import { useAppConfig } from "../../../hooks/useAppConfig";
import { ConfigType } from "../../../contexts/AppConfigContext";
import InputMask from "react-input-mask";
import { cpf } from "cpf-cnpj-validator";
import { cpfCnpjNoMask } from "../../../functions/mask";
import api from "../../../services/api";
import { usePluginspace } from "../../../hooks/usePluginspace";
import { Loading } from "../../../components/Loading";
import Swal from "sweetalert2";

const CreateAccount: FC<any> = () => {
  const { getAppConfig } = useAppConfig();
  const { getToken } = usePluginspace();
  const [config, setConfig] = useState<ConfigType | void>();
  const navigate = useNavigate();

  const [maskCpfjCnpj, setmaskCpfjCnpj] = useState("999.999.999-99");

  const [cpfCustomer, setCpfCustomer] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [name, setName] = useState("");
  const [termo, setTermo] = useState(false);

  const [newCustomer, setNewCustomer] = useState(true);

  const [alarmCpf, setAlarmCpf] = useState(false);
  const [alarmEmail, setAlarmEmail] = useState(false);

  const [loading, setLoading] = useState(true);

  const { pluginspace_id } = useParams();

  async function findCustomer() {
    if (
      cpfCustomer === undefined ||
      cpfCustomer[0] === "_" ||
      !cpf.isValid(cpfCustomer)
    ) {
      setAlarmCpf(true);
    } else {
      setAlarmCpf(false);
    }
    setLoading(true);
    const cpfWithouthMask = cpfCnpjNoMask(cpfCustomer);

    await api
      .post(
        `/api/customer/filter`,
        {
          cpf: cpfWithouthMask,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response: any) => {
        setLoading(false);
        if (response.data.data.length > 0) {
          const data = response.data.data[0];

          if (data.name) setName(data.name);
          if (data.email) setEmail(data.email);

          setNewCustomer(false);
        }
      })
      .catch((err: any) => {
        setLoading(false);
        console.log(err);
      });
  }

  async function findCustomerEmail() {
    return await api
      .post(
        `/api/customer/filter_internal`,
        {
          email: email,
        },
        {
          headers: {
            Authorization: `Bearer ${await getToken()}`,
          },
        },
      )
      .then(async (response: any) => {
        if (response.data.data.length > 0) {
          return true;
        } else {
          return false;
        }
      })
      .catch((err: any) => {
        setLoading(false);
        console.log(err);
        return true;
      });
  }

  const getConfig = async () => {
    try {
      setLoading(true);
      const configData = await getAppConfig();
      setConfig(configData);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const cadastro = async () => {
    // 1. Validações de formulário (Mantidas como você tinha)
    if (password && password.length < 4) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Senha muito curta, minimo de 5 caracteres.",
      });
      return;
    }

    if (
      !name ||
      !email ||
      !cpfCustomer ||
      !password ||
      !passwordAgain ||
      !termo
    ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Verifique se todos os campos foram preenchidos.",
      });
      setPassword("");
      setPasswordAgain("");
      return;
    }

    if (password !== passwordAgain) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "As senhas digitadas não são iguais.",
      });
      setPassword("");
      setPasswordAgain("");
      return;
    }

    setLoading(true);

    // 2. Verificação de existência por e-mail (Mantida)
    const existCustomerWithEmail = await findCustomerEmail();
    if (existCustomerWithEmail && newCustomer) {
      setLoading(false);
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        text: "Já existe uma conta com esse email.",
      });
      return;
    }

    const customer = {
      name: name,
      email: email,
      doc: cpfCnpjNoMask(cpfCustomer),
      cpf: cpfCnpjNoMask(cpfCustomer),
      password: password,
      optinWhatsapp: false,
      gender: "",
    };

    // 3. Chamada à API e Tratamento de Resposta
    await api
      .post(`/api/customer/new_customer`, customer, {
        headers: { Authorization: `Bearer ${await getToken()}` },
      })
      .then(async (response: any) => {
        setLoading(false);
        const data = response.data;

        // CASO A: Cliente já validado (Não faz nada, apenas avisa e loga)
        if (data.alreadyValidated) {
          Swal.fire({
            icon: "info",
            title: "Bem-vindo de volta!",
            text: "Você já possui um cadastro ativo. Prossiga para o login.",
          });
          navigate(`/${pluginspace_id}/auth`);
        }
        // CASO B: Cliente novo ou precisa de validação por e-mail
        else if (data.needsValidation) {
          localStorage.setItem(
            "payload",
            JSON.stringify({ email: email, doc: cpfCustomer }),
          );
          navigate("validation");
        }
        // CASO C: Cliente novo, mas SMTP estava desligado (Validado automaticamente)
        else {
          Swal.fire({
            icon: "success",
            title: "Cadastro concluído!",
            text: "Sua conta foi ativada com sucesso.",
          });
          navigate(`/${pluginspace_id}/register/success`);
        }
      })
      .catch((err: any) => {
        setLoading(false);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Erro ao realizar o cadastro!",
        });
        console.log(err);
      });
  };

  function validarEmail(email: string) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  useEffect(() => {
    getConfig();
  }, []);

  const handleBlurEmail = () => {
    if (!validarEmail(email) && email !== "") {
      setAlarmEmail(true);
      setEmail("");
    } else {
      setAlarmEmail(false);
    }
  };

  const primaryColor = config?.webappcolor?.webappbutton || "rgb(7, 139, 216)";

  return (
    <>
      {loading ? (
        /* Container que ocupa a tela toda */
        <div className="loading-container" style={{ backgroundColor: "#FFF" }}>
          <Loading type="spinningBubbles" color="#FFF" width={64} height={64} />
        </div>
      ) : (
        /* Conteúdo encapsulado idêntico ao login */
        <div className="content-main">
          {/* Botão de Voltar Padronizado */}
          <button className="btn-back" onClick={() => navigate(-1)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="15 18 9 12 15 6"></polyline>
            </svg>
            Voltar
          </button>

          <div className="content-header">
            <h1 style={{ color: primaryColor }}>Criar Conta</h1>
          </div>

          <div className="content-inputs">
            {/* CPF */}
            <div className="input-group">
              <div className="input-header">
                <label>CPF:</label>
              </div>
              <InputMask
                className="myinput"
                mask={maskCpfjCnpj}
                placeholder="123.456.789-00"
                type="text"
                value={cpfCustomer}
                onChange={(event) => setCpfCustomer(event.target.value)}
                onBlur={() => {
                  findCustomer();
                }}
              />
              {alarmCpf && <p className="alarm-text">Informe um CPF válido</p>}
            </div>

            {/* Nome */}
            <div className="input-group">
              <div className="input-header">
                <label>Nome Completo:</label>
              </div>
              <input
                className="myinput"
                type="text"
                placeholder="Seu nome"
                value={name}
                onChange={(event) => setName(event.target.value)}
              />
            </div>

            {/* Email */}
            <div className="input-group">
              <div className="input-header">
                <label>Email:</label>
              </div>
              <input
                className="myinput"
                type="email"
                placeholder="exemplo@email.com"
                value={email}
                onBlur={handleBlurEmail}
                onChange={(event) => setEmail(event.target.value)}
              />
              {alarmEmail && (
                <p className="alarm-text">Informe um Email válido</p>
              )}
            </div>

            {/* Senha */}
            <div className="input-group">
              <div className="input-header">
                <label>Senha:</label>
              </div>
              <input
                className="myinput"
                type="password"
                placeholder="******"
                value={password}
                onChange={(event) => setPassword(event.target.value)}
              />
            </div>

            {/* Repetir Senha */}
            <div className="input-group">
              <div className="input-header">
                <label>Repita a Senha:</label>
              </div>
              <input
                className="myinput"
                type="password"
                placeholder="******"
                value={passwordAgain}
                onChange={(event) => setPasswordAgain(event.target.value)}
              />
            </div>

            {/* Termos de Uso */}
            <div className="checkbox-group">
              <input
                type="checkbox"
                checked={termo}
                onChange={(event) => setTermo(event.target.checked)}
              />
              <span>
                Aceito os <a style={{ color: primaryColor }}>termos de uso</a>{" "}
                do sistema
              </span>
            </div>

            {/* Botão de Cadastro */}
            <button
              className="btn-primary"
              style={{ background: primaryColor }}
              onClick={() => cadastro()}
            >
              Cadastrar
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export { CreateAccount };
